import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'sr:external-institutions',
    content: {
      root: {
        elements: [
          {
            height: 800,
            content: {
              widget: {
                widget: {
                  alias:
                    'sr.external-institutions.widgets.external-institutions-table',
                },
              },
            },
          },
        ],
      },
    },
    description: 'External Institutions',
    name: 'External Institutions',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
